<section class="d-flex flex-column align-items-stretch h-100">
  @if (demo.enabled && demo.paymentIsSimulated) {
  <div class="alert alert-warning py-3 px-4 mb-4" data-testid="cart-simulated-notice">
    <span class="fs-8">นี่คือระบบสาธิต การสั่งซื้อเป็นการจำลอง ไม่มีการตัดเงินจริง</span>
  </div>
  }
  <div class="scroll-y me-n5 pe-0 flex-1 flex-grow-1" [ngClass]="!isDrawer ? 'h-300px h-lg-auto' : ''"
    data-kt-element="carts" data-kt-scroll="true" data-kt-scroll-activate="{default: false, lg: true}"
    data-kt-scroll-max-height="auto" [attr.data-kt-scroll-dependencies]="
      isDrawer
        ? '#kt_drawer_cart_order_header, #kt_drawer_cart_order_footer'
        : '#kt_header, #kt_toolbar, #kt_footer, #kt_cart_order_header, #kt_cart_order_footer'
    " [attr.data-kt-scroll-wrappers]="
      isDrawer
        ? '#kt_drawer_cart_order_body'
        : '#kt_content, #kt_cart_order_body'
    " [attr.data-kt-scroll-offset]="isDrawer ? '0px' : '-2px'">
    <div>
      @for (course_item of userCart()?.course_list; track $index) {

      <app-cart-item [course_item]="course_item" [can_delete]="true"
        (onDelete)="deleteCartItem($event)"></app-cart-item>

      @if($index !== userCart().course_list.length-1){
      <div class="separator my-8"></div>
      } } @empty {
      <!-- An empty cart used to render nothing at all, so the drawer opened on a
           blank panel with ฿0.00, a coupon box and a live "ชำระเงิน" button
           under it. Say what is going on and offer the way out. -->
      <div class="cart-empty d-flex flex-column align-items-center text-center" data-testid="cart-empty">
        <span class="cart-empty__mark rounded-circle d-inline-flex align-items-center justify-content-center mb-5">
          <app-keenicon name="handcart" class="fs-3x text-primary"></app-keenicon>
        </span>
        <p class="cart-empty__head fw-bold">{{ "APP.CART_EMPTY" | translate }}</p>
        <p class="cart-empty__body">{{ "APP.CART_EMPTY_HINT" | translate }}</p>
        <a class="btn btn-light-primary" routerLink="/courses" id="kt_drawer_cart_close">
          {{ "LANDING_PAGE.ADVICE_BUTTON" | translate }}
        </a>
      </div>
      }
    </div>
  </div>

  <!-- Totals, coupon and checkout only exist once there is something to total. -->
  @if (userCart()?.course_list?.length) {
  <div class="card-footer pt-4 mt-4 px-0 pb-0" [id]="isDrawer ? 'kt_drawer_cart_order_footer' : 'kt_cart_order_footer'">
    <app-cart-summary [userCart]="userCart" (onUseDiscount)="discountActive($event)" (onPayOrder)="createTransaction()"
      (onCancelOrder)="clearCart()"></app-cart-summary>
  </div>
  }
</section>